import React, {Component,PropTypes} from 'react'
import ReactDOM from 'react-dom';
import {Link} from 'react-router'
import firebase from '../config/database'
import Fields from '../components/fields/Fields.js'
import Input from '../components/fields/Input.js';
import Table from  '../components/tables/Table.js'
import Config, { userDetails } from   '../config/app';
import Common from '../common.js';
import Notification from '../components/Notification';
import SkyLight from 'react-skylight';
import INSERT_STRUCTURE from "../config/firestoreschema.js"
import FirebasePaginator from "firebase-paginator"
import NavBar from '../components/NavBar'
import moment from 'moment';
import * as firebaseREF from 'firebase';
require("firebase/firestore");

const ROUTER_PATH="/firestoreadmin/";
var Loader = require('halogen/PulseLoader');

class Firestoreadmin extends Component {
  
  constructor(props){
    super(props);
    
    //Create initial step
    this.state={
      documents:[],
      collections:[],
      currentCollectionName:"",
      isCollection:false,
      isDocument:false,
      keyToDelete:null,
      pathToDelete:null,
      theSubLink:null,
      fieldsOfOnsert:null,
      isLoading:true,
      showAddCollection:""
    };

    //Bind function to this
    this.getCollecitonDataFromFireStore=this.getCollecitonDataFromFireStore.bind(this);
    this.resetDataFunction=this.resetDataFunction.bind(this);
    this.processRecords=this.processRecords.bind(this);
    this.updateAction=this.updateAction.bind(this);
    this.cancelDelete=this.cancelDelete.bind(this);
    this.cancelAddFirstItem=this.cancelAddFirstItem.bind(this);
    this.doDelete=this.doDelete.bind(this);
    this.deleteFieldAction=this.deleteFieldAction.bind(this);
    this.refreshDataAndHideNotification=this.refreshDataAndHideNotification.bind(this);
    this.addKey=this.addKey.bind(this);
    this.showSubItems=this.showSubItems.bind(this);
    this.updatePartOfObject=this.updatePartOfObject.bind(this);
    this.addDocumentToCollection=this.addDocumentToCollection.bind(this);
    this.addItemToArray=this.addItemToArray.bind(this);
  }

  /**
   * Step 0a
   * Start getting data
   */
  componentDidMount(){
      this.findFirestorePath();
  }

  /**
  * Step 0b
  * Resets data function
  */
  resetDataFunction(){
    var newState={};
        newState.documents=[];
        newState.collections=[];
        newState.currentCollectionName="";
        newState.fieldsAsArray=[];
        newState.arrayNames=[];
        newState.fields=[];
        newState.arrays=[];
        newState.elements=[];
        newState.elementsInArray=[];
        newState.theSubLink=null;

    this.setState(newState);
    this.findFirestorePath();
  }

  /**
   * Step 0c
   * componentWillReceiveProps event of React, fires when component is mounted and ready to display
   * Start connection to firebase
   */
  componentWillReceiveProps(nextProps, nextState) {
      console.log("Next SUB: "+nextProps.params.sub);
      console.log("Prev SUB : "+this.props.params.sub);
      if(nextProps.params.sub==this.props.params.sub){
          console.log("update now");
          this.setState({isLoading:true})
          this.resetDataFunction();
      }
  }

  /**
   * Step 0d
   * getMeTheFirestorePath created firestore path based on the router parh
   */
  getMeTheFirestorePath(){
    var thePath=(this.props.route.path.replace(ROUTER_PATH,"").replace(":sub",""))+(this.props.params&&this.props.params.sub?this.props.params.sub:"").replace(/\+/g,"/");;
    return thePath;
  }

  /**
   * Step 1
   * Finds out the Firestore path
   * Also creates the path that will be used to access the insert
   */
  findFirestorePath(){
      var pathData={}
      if(this.props.params&&this.props.params.sub){
          pathData.lastSub=this.props.params.sub;
      }

      //Find the firestore path
      var firebasePath=this.getMeTheFirestorePath();
      pathData.firebasePath=firebasePath;

      //Find last path - the last item
      var subPath=this.props.params&&this.props.params.sub?this.props.params.sub:""
      var items=subPath.split(Config.adminConfig.urlSeparator);
      pathData.lastPathItem=Common.capitalizeFirstLetter(items[items.length-1]);
      pathData.completePath=subPath;

      //Save this in state
      this.setState(pathData);

      //Go to next step of finding the collection data
      this.getCollecitonDataFromFireStore(firebasePath);
  }

  /**
  * Step 2
  * Connect to firestore to get the current item we need
  * @param {String} collection - this infact can be collection or document
  */
  getCollecitonDataFromFireStore(collection){
    
    //Create the segmments based on the path / collection we have
    var segments = collection.split("/");
    var lastSegment=segments[segments.length-1];

    //Is this a call to a collections data
    var isCollection=segments.length%2;

    //Reference to this
    var _this=this;

    //Save know info for now
    this.setState({
      currentCollectionName:segments[segments.length-1],
      isCollection:isCollection,
      isDocument:!isCollection,
    })

    //Get reference to firestore
    var db = firebase.app.firestore();
   

    //Here, we will save the documents from collection
    var documents=[];

    //[Xavi] here we will gather the user and filter the usercliniques

    
     var usercliniques = [];
     var cliniquesdocuments = [];
     


     var user = firebase.app.auth().currentUser;
     var name, email, photoUrl, uid, emailVerified;
     var videoid;
     var usuari;
     var refclinica;
     var refclinicaget;
     
     if (user != null) {
       name = user.displayName;
       email = user.email;
       photoUrl = user.photoURL;
       emailVerified = user.emailVerified;
       uid = user.uid;  // The user's ID, unique to the Firebase project. Do NOT use
                        // this value to authenticate with your backend server, if
                        // you have one. Use User.getToken() instead.
     }

    // Get the ID clinica 

    var database = firebase.app.firestore();
    var databaseupdate = firebase.app.firestore();
    var dbvideos = firebase.app.firestore();
    var dbvideosdb = firebase.app.firestore();
    var dbdata = firebase.app.firestore();

//UPDATE VIDEO_COLLECTION TABLE IF REQUIRED
// NOT NEEDED RIGHT NOW AS IT'S DONE EVERYTIME THAT WE UPDATE A VIDEO

/*

if (collection == "videos_disponibles"){

      databaseupdate.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {
     
        Snapshot.forEach(function(docupdate) {
    
          var usuariupdate = docupdate.data();

           // USE REFERNCE INSTEAD OF ID 
           var refclinica = db.collection("cliniques").doc(usuariupdate.clinica);
           usuariupdate.clinica=refclinica;

              dbdata.collection("videos_disponibles").where("idclinica" , "==" ,usuariupdate.clinica).get().then(function(querySnapshot) {
              querySnapshot.forEach(function(updatedoc) {
            //Get the object
              
               var currentStatus=updatedoc.data();
          
               var docid = updatedoc.id;
                
           
            //{Xavi} GET THE DATA FROM Videos

             var docRef = dbvideos.collection("videos").doc(currentStatus.idvideo.id);
             
              docRef.get().then(function(docvideo) {
                
                
              

            //{xavi}add data to the documment
                  var datavideo = docvideo.data();



                  
              if ((currentStatus.a_title != datavideo.title ) || (currentStatus.preview != datavideo.photo ) || (currentStatus.a_clinica != usuariupdate.nomclinica )|| (currentStatus.preview_video != datavideo.video )   ) {

                      var videosRef = dbvideosdb.collection("videos_disponibles").doc(docid);
                      
                      var updatevideos={
                        a_title: datavideo.title,
                        preview: datavideo.photo,
                        a_clinica: usuariupdate.nomclinica,
                        preview_video: datavideo.video
                      };
   
                     videosRef.set(updatevideos, { merge: true });

                   
                 }
                 });
               });
             });
          });
        });

      }
*/

// UPDATE SECCIONS WITH DIFFERENT CATEGORIES




   //UPDATE PLAYLIST NOM CLINICA

      if (collection == "playlists"){

        databaseupdate.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {
       
          Snapshot.forEach(function(docupdate) {
      
            var usuariupdate = docupdate.data();
  
  
                dbdata.collection("playlists").where("idclinica" , "==" ,usuariupdate.clinica).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(updatedoc) {
              //Get the object
                var currentStatus=updatedoc.data();
                var docid = updatedoc.id;
  
  
                   
              //{xavi}add data to the documment
                
                    
                if (currentStatus.clinica != usuariupdate.nomclinica ) {
  
                        var videosRef = dbvideosdb.collection("playlists").doc(docid);
                        
                        var updatevideos={
                          clinica: usuariupdate.nomclinica,
                        };
     
                       videosRef.set(updatevideos, { merge: true });
  
                     
                   }
                   });
                 
               });
            });
          });
  
        }
      
 //UPDATE PLAYLIST ENQUESTAS

      if (collection == "enquestes"){

        

        databaseupdate.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {
       
          Snapshot.forEach(function(docupdate) {
      
            var usuariupdate = docupdate.data();

            // USE REFERNCE INSTEAD OF ID 
            var refclinica = db.collection("cliniques").doc(usuariupdate.clinica);
            usuariupdate.clinica=refclinica;
          
  
  
                dbdata.collection("enquestes").where("idclinica" , "==" ,usuariupdate.clinica).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(updatedoc) {
              //Get the object
                var currentStatus=updatedoc.data();
                var docid = updatedoc.id;
  
  
                   
              //{xavi}add data to the documment
                
                    
                if (currentStatus.clinica != usuariupdate.nomclinica ) {
  
                        var videosRef = dbvideosdb.collection("enquestes").doc(docid);
                        
                        var updatevideos={
                          clinica: usuariupdate.nomclinica,
                        };
     
                       videosRef.set(updatevideos, { merge: true });
  
                     
                   }
                   });
                 
               });
            });
          });
  
        }


// UPDATE COUNTERS 


if (collection == "counters"){

  databaseupdate.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {
 
    Snapshot.forEach(function(docupdate) {

      var usuariupdate = docupdate.data();


          dbdata.collection("counters").where("idclinica" , "==" ,usuariupdate.clinica).get().then(function(querySnapshot) {
          querySnapshot.forEach(function(updatedoc) {
        //Get the object
          var currentStatus=updatedoc.data();
          videoid = currentStatus.idvideo;
          var docid = updatedoc.id;

       
        //{Xavi} GET THE DATA FROM Videos

          var docRef = dbvideos.collection("videos").doc(videoid);
         
          docRef.get().then(function(docvideo) {
            
             
        //{xavi}add data to the documment
              var datavideo = docvideo.data();

              
          if ((currentStatus.a_title != datavideo.title ) || (currentStatus.preview != datavideo.photo ) ) {

                  var videosRef = dbvideosdb.collection("counters").doc(docid);
                  
                  var updatevideos={
                    a_title: datavideo.title,
                    preview: datavideo.photo,
                    clinica: usuariupdate.nomclinica,
              //      preview_video: datavideo.video_preview
                  };

                 videosRef.set(updatevideos, { merge: true });

               
             }
             });
           });
         });
      });
    });

  }





if(isCollection){
  

  database.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {
     
    Snapshot.forEach(function(doc2) {

      usuari = doc2.data();

          if ((collection == "enquestes") || (collection == "videos_disponibles")){



            // Create a reference to the specific document you want to search with
            var refclinicaget = db.collection("cliniques").doc(usuari.clinica);
            usuari.clinica=refclinicaget;
        

          }

   // SORT REPRODCUCIONS FROM THE HIGHER NUMBER OF REPRODUCCIONS       

   switch ( collection) {

        case "counters" :

        db.collection(collection).where("idclinica" , "==" ,usuari.clinica).orderBy("reproduccions", "desc").get().then(function(querySnapshot) {
          var datacCount=0;
           querySnapshot.forEach(function(doc) {

             
               
          //Increment counter
            datacCount++;

          //Get the object
           var currentDocument=doc.data();

           

           //XAVI JUST SHOW GLOBAL STADISTICS

           if ((currentDocument.type != "global") && (collection == "counters")) {

                 //DON'T ADD THE DATA TO DOCUMENTS

           }else {

                   //Sace uidOfFirebase inside him
                   currentDocument.uidOfFirebase=doc.id;

                   console.log(doc.id, " => ", currentDocument);

                   //Save in the list of documents
                   documents.push(currentDocument)
           }
         });


          console.log("DOCS----");
         console.log(documents);

            //Save the douments in the sate
           _this.setState({
          isLoading:false,
          documents:documents,
          showAddCollection:datacCount==0?collection:""
           })
         if(datacCount==0){
        _this.refs.addCollectionDialog.show();
         }
      console.log(_this.state.documents);
          });
    



         break;


     case "seccions" :


    
     db.collection(collection).where("idclinica" , "==" ,usuari.clinica).orderBy("posicio", "asc").get().then(function(querySnapshot) {
      var datacCount=0;
       querySnapshot.forEach(function(doc) {

         
           
      //Increment counter
        datacCount++;

      //Get the object
       var currentDocument=doc.data();

       

       //XAVI JUST SHOW GLOBAL STADISTICS


               //Sace uidOfFirebase inside him
               currentDocument.uidOfFirebase=doc.id;

               console.log(doc.id, " => ", currentDocument);

               //Save in the list of documents
               documents.push(currentDocument)
       
     });


      console.log("DOCS----");
     console.log(documents);

        //Save the douments in the sate
       _this.setState({
      isLoading:false,
      documents:documents,
      showAddCollection:datacCount==0?collection:""
       })
     if(datacCount==0){
    _this.refs.addCollectionDialog.show();
     }
  console.log(_this.state.documents);
      });
        


     break;


     case "cliniques":


     db.collection(collection).where("administrador" , "==" ,user.email).get().then(function(querySnapshot) {
      var datacCount=0;
      querySnapshot.forEach(function(doc) {

        //Increment counter
        datacCount++;
    
        //Get the object
        var currentDocument=doc.data();

        //Sace uidOfFirebase inside him
        currentDocument.uidOfFirebase=doc.id;

        console.log(doc.id, " => ", currentDocument);

        //Save in the list of documents
        documents.push(currentDocument)
      });
      console.log("DOCS----");
      console.log(documents);

      //Save the douments in the sate
      _this.setState({
        isLoading:false,
        documents:documents,
        showAddCollection:datacCount==0?collection:""
      })
      if(datacCount==0){
        _this.refs.addCollectionDialog.show();
      }
      console.log(_this.state.documents);
      });

     break;

     case "promocions":


     db.collection(collection).where("idclinica" , "==" ,usuari.clinica).where("formato_promo" , "==" ,"manual").orderBy("promocion_activa", "desc").get().then(function(querySnapshot) {
      var datacCount=0;
      querySnapshot.forEach(function(doc) {

        //Increment counter
        datacCount++;
    
        //Get the object
        var currentDocument=doc.data();

        //Sace uidOfFirebase inside him
        currentDocument.uidOfFirebase=doc.id;

        console.log(doc.id, " => ", currentDocument);

        //Save in the list of documents
        documents.push(currentDocument)
      });
      console.log("DOCS----");
      console.log(documents);

      //Save the douments in the sate
      _this.setState({
        isLoading:false,
        documents:documents,
        showAddCollection:datacCount==0?collection:""
      })
      if(datacCount==0){
        _this.refs.addCollectionDialog.show();
      }
      console.log(_this.state.documents);
      });

     break;

// FILTRAR LOS RESULTADOS PARA LOS VIDEOS ACTIVOS

     case "videos_disponibles":

                db.collection(collection).where("idclinica" , "==" ,usuari.clinica).orderBy("tv", "desc").orderBy("tablet", "desc").orderBy("app", "desc").get().then(function(querySnapshot) 
     
                {
                 var datacCount=0;
                 querySnapshot.forEach(function(doc) {
           
                   //Increment counter
                   datacCount++;
               
                   //Get the object
                   var currentDocument=doc.data();
           
                   //Sace uidOfFirebase inside him
                   currentDocument.uidOfFirebase=doc.id;
           
                   console.log(doc.id, " => ", currentDocument);
           
                   //Save in the list of documents
                   documents.push(currentDocument)
                 });
                 console.log("DOCS----");
                 console.log(documents);
           
                 //Save the douments in the sate
                 _this.setState({
                   isLoading:false,
                   documents:documents,
                   showAddCollection:datacCount==0?collection:""
                 })
                 if(datacCount==0){
                   _this.refs.addCollectionDialog.show();
                 }
                 console.log(_this.state.documents);
                 });


     break;


     default :


       // [Xavi]COLLECTIONS-GET DOCUMENTS BASED ON CLINICS
       
    db.collection(collection).where("idclinica" , "==" ,usuari.clinica).get().then(function(querySnapshot) {
      var datacCount=0;
      querySnapshot.forEach(function(doc) {

        //Increment counter
        datacCount++;
    
        //Get the object
        var currentDocument=doc.data();

        //Sace uidOfFirebase inside him
        currentDocument.uidOfFirebase=doc.id;

        console.log(doc.id, " => ", currentDocument);

        //Save in the list of documents
        documents.push(currentDocument)
      });
      console.log("DOCS----");
      console.log(documents);

      //Save the douments in the sate
      _this.setState({
        isLoading:false,
        documents:documents,
        showAddCollection:datacCount==0?collection:""
      })
      if(datacCount==0){
        _this.refs.addCollectionDialog.show();
      }
      console.log(_this.state.documents);
  });

   }
   

            });   
  });

  
  






      }else{
        //DOCUMENT - GET FIELDS && COLLECTIONS
        var referenceToCollection=collection.replace("/"+lastSegment,"");

        //Create reference to the document itseld
        var docRef = db.collection(referenceToCollection).doc(lastSegment);

        //Get the starting collectoin
        var parrentCollection=segments;
        parrentCollection.splice(-1,1);

        //Find the collections of this document
        this.findDocumentCollections(parrentCollection);
        
        docRef.get().then(function(doc) {
            if (doc.exists) {
                console.log("Document data:", doc.data());

                //Directly process the data
                _this.processRecords(doc.data())  
            } else {
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        }); 
      }
   }

  /**
   * Step 3
   * findDocumentCollections - what collections should we display / currently there is no way to get collection form docuemnt
   * @param {Array} chunks - the collection / documents
   */
  findDocumentCollections(chunks){
      console.log("Search for the schema now of "+chunks);

      //At start is the complete schema
      var theInsertSchemaObject=INSERT_STRUCTURE;
      var cuurrentFields=null;
      console.log("CHUNKS");
      console.log(chunks);
      
      //Foreach chunks, find the collections / fields
      chunks.map((item,index)=>{
          console.log("current chunk:"+item);

          //Also make the last object any
          //In the process, check if we have each element in our schema
          if(theInsertSchemaObject!=null&&theInsertSchemaObject&&theInsertSchemaObject[item]&&theInsertSchemaObject[item]['collections']){
              var isLastObject=(index==(chunks.length-1));
              
              if(isLastObject&&theInsertSchemaObject!=null&&theInsertSchemaObject[item]&&theInsertSchemaObject[item]['fields']){
                cuurrentFields=theInsertSchemaObject[item]['fields'];
              }

              if(isLastObject&&theInsertSchemaObject!=null){
                //It is last
                theInsertSchemaObject=theInsertSchemaObject[item]['collections'];
              }else{
                theInsertSchemaObject=theInsertSchemaObject[item]['collections'];
              }
          }else{
            theInsertSchemaObject=[];
          }
          console.log("Current schema");
          console.log(theInsertSchemaObject);


      })
      
      //Save the collection to be shown as button and fieldsOfOnsert that will be used on inserting object
      this.setState({collections:theInsertSchemaObject,fieldsOfOnsert:cuurrentFields})
  }

  /**
   * Step 4
   * Processes received records from firebase
   * @param {Object} records
   */
  processRecords(records){
      console.log(records);

      var fields={};
      var arrays={};
      var elements=[];
      var elementsInArray=[];
      var newState={};
      var directValue="";
      newState.fieldsAsArray=fieldsAsArray;
      newState.arrayNames=arrayNames;
      newState.fields=fields;
      newState.arrays=arrays;
      newState.elements=elements;
      newState.directValue=directValue;
      newState.elementsInArray=elementsInArray;
      newState.records=null;

      this.setState(newState);

      //Each display is consisted of
      //Fields   - This are string, numbers, photos, dates etc...
      //Arrays   - Arrays of data, ex items:[0:{},1:{},2:{}...]
      //         - Or object with prefixes that match in array
      //Elements - Object that don't match in any prefix for Join - They are represented as buttons.

      //In FireStore
      //GeoPoint
      //DocumentReference

      //If record is of type array , then there is no need for parsing, just directly add the record in the arrays list
      if(Common.getClass(records)=="Array"){
          //Get the last name
          console.log("This is array");
          var subPath=this.props.params&&this.props.params.sub?this.props.params.sub:""
          var allPathItems=subPath.split("+");
          console.log(allPathItems)
          if(allPathItems.length>0){
              var lastItem=allPathItems[allPathItems.length-1];
              console.log(lastItem);
              arrays[lastItem]=records;

          }
          //this.setState({"arrays":this.state.arrays.push(records)})
      }else if(Common.getClass(records)=="Object"){
          //Parse the Object record
          for (var key in records){
              if (records.hasOwnProperty(key)) {
                  var currentElementClasss=Common.getClass(records[key]);
                  console.log(key + "'s class is: " + currentElementClasss);

                  //Add the items by their type
                  if(currentElementClasss=="Array"){
                      //Add it in the arrays  list
                      arrays[key]=records[key];
                  }else if(currentElementClasss=="Object"){
                      //Add it in the elements list
                      var isElementMentForTheArray=false; //Do we have to put this object in the array
                      for (var i=0;i<Config.adminConfig.prefixForJoin.length;i++){
                          if(key.indexOf(Config.adminConfig.prefixForJoin[i])>-1){
                              isElementMentForTheArray=true;
                              break;
                          }
                      }

                      var objToInsert=records[key];
                      objToInsert.uidOfFirebase=key;

                      if(isElementMentForTheArray){
                          //Add this to the merged elements
                          elementsInArray.push(objToInsert);
                      }else{
                          //Add just to elements
                          elements.push(objToInsert);
                      }

                  }else if(currentElementClasss!="undefined"&&currentElementClasss!="null"){
                      //This is string, number, or Boolean
                      //Add it to the fields list
                      fields[key]=records[key];
                  }else if(currentElementClasss=="GeoPoint"){
                      //This is GeoPOint
                      //Add it to the fields list
                      fields[key]=records[key];
                  }else if(currentElementClasss=="DocumentReference"){
                      //This is DocumentReference
                      //Add it to the fields list
                      fields[key]=records[key];
                  }
                  
              }
          }
      }if(Common.getClass(records)=="String"){
        console.log("We have direct value of string");
        directValue=records;
      }

      //Convert fields from object to array
      var fieldsAsArray=[];
      console.log("Add the items now inside fieldsAsArray");
      console.log("Current schema");
      console.log(this.state.currentInsertStructure)
      //currentInsertStructure
      var keysFromFirebase=Object.keys(fields);
      console.log("keysFromFirebase")
      console.log(keysFromFirebase)
      var keysFromSchema=Object.keys(this.state.currentInsertStructure||{});
      console.log("keysFromSchema")
      console.log(keysFromSchema)

      keysFromSchema.forEach((key)=>{
        if (fields.hasOwnProperty(key)) {


          fieldsAsArray.push({"theKey":key,"value":fields[key]})
          var indexOfElementInFirebaseObject = keysFromFirebase.indexOf(key);
          
          if (indexOfElementInFirebaseObject > -1) {
              keysFromFirebase.splice(indexOfElementInFirebaseObject, 1);
          }
        }
      });

      console.log("keysFromFirebase")
      console.log(keysFromFirebase)

      keysFromFirebase.forEach((key)=>{
        if (fields.hasOwnProperty(key)) {
          fieldsAsArray.push({"theKey":key,"value":fields[key]})
        }
      });



      //Get all array names
      var arrayNames=[];
      Object.keys(arrays).forEach((key)=>{
          arrayNames.push(key)
      });

      var newState={};
      newState.fieldsAsArray=fieldsAsArray;
      newState.arrayNames=arrayNames;
      newState.fields=fields;
      newState.arrays=arrays;
      newState.isJustArray=Common.getClass(records)=="Array";
      newState.elements=elements;
      newState.elementsInArray=elementsInArray;
      newState.directValue=directValue;
      newState.records=records;
      newState.isLoading=false;

      console.log("THE elements")
      console.log(elements);

      //Set the new state
      this.setState(newState);

      //Additional init, set the DataTime, check format if something goes wrong
      window.additionalInit();
  }

  /**
   *
   * Create R Update D
   *
   */

  /**
  * processValueToSave  - helper for saving in Firestore , converts value to correct format
  * @param {value} value
  * @param {type} type of field
  */
  processValueToSave(value,type){
      //To handle number values
      if(!isNaN(value)){
        value=Number(value);
      }

      //To handle boolean values
      value=value==="true"?true:(value==="false"?false:value);

    
      if(type=="date"){
        //To handle date values
        if(moment(value).isValid()){
          value=moment(value).toDate();
          //futureStartAtDate = new Date(moment().locale("en").add(1, 'd').format("MMM DD, YYYY HH:MM"))
        }
      }

      return value;
  }

  /**
  * updatePartOfObject  - updates sub data from document in firestore, this also does Delete
  * @param {String} key to be updated
  * @param {String} value
  * @param {Boolean} refresh after action
  * @param {String} type of file
  * @param {String} firebasePath current firestore path
  * @param {String} byGivvenSubLink force link to field
  * @param {Function} callback function after action
  */
  updatePartOfObject(key,value,dorefresh=false,type=null,firebasePath,byGivvenSubLink=null,callback=null){
    var subLink=this.state.theSubLink;
    if(byGivvenSubLink!=null){
      subLink=byGivvenSubLink;
    }
    console.log("Sub save "+key+" to "+value+" and the path is "+firebasePath+" and theSubLink is "+subLink);
    var chunks=subLink.split(Config.adminConfig.urlSeparatorFirestoreSubArray);
    var _this=this;
    //First get the document
    //DOCUMENT - GET FIELDS && COLLECTIONS
        var docRef = firebase.app.firestore().doc(firebasePath);
        docRef.get().then(function(doc) {
            if (doc.exists) {
              var numChunks=chunks.length-1;
              var doc=doc.data();
              if(value=="DELETE_VALUE"){
                if(numChunks==2){
                   doc[chunks[1]].splice(chunks[2], 1);
                }
                if(numChunks==1){
                   doc[chunks[1]]=null;
                }
              }else{
                //Normal update, or insert
                if(numChunks==2){
                  doc[chunks[1]][chunks[2]]=value
                }
                if(numChunks==1){
                  doc[chunks[1]][key]=value
                }
              }
              
                console.log("Document data:", doc);
                _this.updateAction(chunks[1],doc[chunks[1]],dorefresh,null,true)
                if(callback){
                  callback();
                }

                //alert(chunks.length-1);
                //_this.processRecords(doc.data())
                //console.log(doc);
                
            } else {
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

   }



   /**
   * Firebase update based on key / value,
   * This function also sets derect name and value
   * @param {String} key
   * @param {String} value
   */
  
  /**
  * updateAction  - updates sub data from document in firestore, this also does Delete
  * @param {String} key to be updated
  * @param {String} value
  * @param {Boolean} refresh after action
  * @param {String} type of file
  * @param {Boolean} forceObjectSave force saving sub object
  */
  updateAction(key,value,dorefresh=false,type=null,forceObjectSave=false){
    value=this.processValueToSave(value,type);
    var firebasePath=(this.props.route.path.replace("/firestoreadmin/","").replace(":sub",""))+(this.props.params&&this.props.params.sub?this.props.params.sub:"").replace(/\+/g,"/");
    if(this.state.theSubLink!=null&&!forceObjectSave){
      this.updatePartOfObject(key,value,dorefresh,type,firebasePath)
    }else{
    
      //value=firebase.firestore().doc("/users/A2sWwzDop0EAMdfxfJ56");
      //key="creator";
      
       console.log("firebasePath from update:"+firebasePath)
      console.log('Update '+key+" into "+value);

      if(key=="NAME_OF_THE_NEW_KEY"||key=="VALUE_OF_THE_NEW_KEY"){
        console.log("THE_NEW_KEY")
        var updateObj={};
        updateObj[key]=value;
        this.setState(updateObj);
        console.log(updateObj);
      }else{
       
        var db = firebase.app.firestore();

        var databaseRef = db.doc(firebasePath);
        var updateObj={};

// XAVI PREVENT A STRING TO CHANGE TO A NUMBER
        if ( (value == 0) && ((key == "esponsors_vetados" ) || (key == "seleccion_videos_playlist" ))){

            value = "";
        }

 // XAVI PREVENT THAT SOME FIELDS BECOME INTEGERS 
      if ( (key == "telefono_centro_1" ) || (key == "telefono_centro_2" ) || (key == "telefono_centro_3" ) || (key == "tags" )|| (key == "zoom" ) || (key == "telefono_fijo" ) ||  (key == "telefono_movil" ) || (key == "skype" ) ){

          if ( typeof(value) == "number"){

              value = value.toString()
          }

      }

 


        var databaseupdate = firebase.app.firestore();
        var dbvideosdb = firebase.app.firestore();
        var dbdata = firebase.app.firestore();
       
        var usuaripromocions = firebase.app.auth().currentUser;

        var categoria1string;
        var categoria2string;
        var categoria3string;
        var categoria4string;
        var categoria5string;
        var usuariclinica;
        var clinicaupdatedata;
        var stringcategoriesclinica;
        var playlistupdate;
        var playlistupdateid;
        var dontupdate = false;

//UPDATE EQUIPO A PROMO






  //UPDATE VIDEOS CORPORATIVOS A VIDEOS DISPONIBLES

 

var dbdata2 = firebase.app.firestore();
var docid;
var videoupdatedata;
var categoria1id;
var categoria2id;
var categoria3id;
var categoria4id;
var categoria5id;
var categoria1updatedata;
var categoria2updatedata;
var categoria3updatedata;
var categoria4updatedata;
var categoria5updatedata;
var categoria1idString;
var categoria2idString;
var categoria3idString;
var categoria4idString;
var categoria5idString;
var idclinicavideocorporativo;
var titlecorporativo;
var refclinicacorporativo;
var video_audience_corporativo;
var video_type_corporativo;
var photo_corporativo;
var video_demo_corporativo;
var categoria1corporate;
var categoria2corporate;
var categoria3corporate;
var categoria4corporate;
var categoria5corporate;
var stringcategories_videosdisponibles;
var video_idioma_corporativo;
var video_plan_corporativo;
var datetime = new Date();






var pos = firebasePath.search("videos_corporativos/"); 

if (pos != -1){


  // Remove from firebasepath the videos/ part

 
  var videoid = firebasePath.replace("videos_corporativos/","");
  var refvideoid = db.collection("videos_corporativos").doc(videoid);

   
  refvideoid.get().then(function(doc) {
    if (doc.exists) {
            console.log("Document data:", doc.data());
            videoupdatedata = doc.data();

             idclinicavideocorporativo = videoupdatedata.idclinica;
             titlecorporativo = videoupdatedata.title;
             refclinicacorporativo = videoupdatedata.refclinica;
             video_audience_corporativo = videoupdatedata.video_audience;
             video_type_corporativo = videoupdatedata.video_type;
             photo_corporativo = videoupdatedata.photo;
             video_demo_corporativo = videoupdatedata.video; 
             video_plan_corporativo = videoupdatedata.video_plan;
             video_idioma_corporativo = videoupdatedata.video_idioma_corporativo;
             categoria1id = videoupdatedata.categories1.id;
             categoria1idString = categoria1id.toString();
             categoria2id = videoupdatedata.categories2.id;
             categoria2idString = categoria2id.toString();
             categoria3id = videoupdatedata.categories3.id;
             categoria3idString = categoria3id.toString();
             categoria4id = videoupdatedata.categories4.id;
             categoria4idString = categoria4id.toString();
             categoria5id = videoupdatedata.categories5.id;
             categoria5idString = categoria5id.toString();
          
             
      

       //UPDATE VIDEOS



       docid= videoid + idclinicavideocorporativo;
       var videosRef = dbvideosdb.collection("videos_disponibles").doc(docid);
       var datetime = new Date();
       


       var updatevideos={

         a_title: titlecorporativo,
         idclinica: refclinicacorporativo,
         idvideo: refvideoid,
         video_audience_selecciovideos: video_audience_corporativo,
         video_type_selecciovideos: video_type_corporativo,
         video_idioma: video_idioma_corporativo,
         video_plan: video_plan_corporativo,
         preview: photo_corporativo,
         updated: datetime,
         app: true,
         tablet: true,
         tv: true,
         video_demo: video_demo_corporativo
         };

       videosRef.set(updatevideos, { merge: true });



//UPDATE CATEGORIES && VIDEOS


if ( (key== "categories1") || (key== "categories2") || (key== "categories3") || (key== "categories4") || (key== "categories5")){

          dbdata2.collection("categories").get().then(function(Snapshot) {

           Snapshot.forEach(function(categoriaupdate) {

              var categoriaupdatedata = categoriaupdate.data();

              if (categoriaupdate.id == categoria1idString){

                categoria1updatedata = categoriaupdatedata.title;
                

                var updatecategoria1={

                 categoria1updatedata_value: categoria1updatedata,
       
                 };

               videosRef.set(updatecategoria1, { merge: true });




                }

              if (categoriaupdate.id == categoria2idString){

              categoria2updatedata = categoriaupdatedata.title;
              



              var updatecategoria2={

               categoria2updatedata_value: categoria2updatedata,
     
               };

             videosRef.set(updatecategoria2, { merge: true });




               }

              if (categoriaupdate.id == categoria3idString){

               categoria3updatedata = categoriaupdatedata.title;
          

               var updatecategoria3={

                 categoria3updatedata_value: categoria3updatedata,
       
                 };

               videosRef.set(updatecategoria3, { merge: true });


               }

              if (categoriaupdate.id == categoria4idString){

             categoria4updatedata = categoriaupdatedata.title;
         

             var updatecategoria4={

               categoria4updatedata_value: categoria4updatedata,
     
               };

             videosRef.set(updatecategoria4, { merge: true });





               }

             if (categoriaupdate.id == categoria5idString){

            categoria5updatedata = categoriaupdatedata.title;
            categoria5corporate = categoria5updatedata;



            var updatecategoria5={

             categoria5updatedata_value: categoria5updatedata,
   
             };

           videosRef.set(updatecategoria5, { merge: true });



               }


// ACTUALITZAR CATEGORIES

                   stringcategories_videosdisponibles = categoria1updatedata + "," + categoria2updatedata + "," + categoria3updatedata + "," +categoria4updatedata + "," +categoria5updatedata + ",";

                    var updatestringcategories={

                        categoria_video : stringcategories_videosdisponibles,

                   };

                  videosRef.set(updatestringcategories, { merge: true });

          
                });

              });

          }      
           
         } else {
           // doc.data() will be undefined in this case
      console.log("No such document!");
       }
         }).catch(function(error) {
    console.log("Error getting document:", error);
     });

  }

//AÑADIR SECCION

if (key == "añadir_seccion"){

  var clinica_equipo_data;
  var codi_clinica_equipo;
  var codi_equipo_playlist;
  var codi_clinica_equipo;
  var codi_equipo_playlist;


  var datetime_equipo = new Date();
  var clinica_equipo_data;


  var refcategoria =  db.collection("categories").doc("1Cwi4AmOn02nc9eOPSQ9");

  var clinicaid_equipo = firebasePath.replace("cliniques/","");
  var refclinicaid_equipo = db.collection("cliniques").doc(clinicaid_equipo);
  

                
  refclinicaid_equipo.get().then(function(doc) {
    if (doc.exists) {
            console.log("Document data:", doc.data());
            clinica_equipo_data = doc.data();


             codi_clinica_equipo = clinica_equipo_data.codi_clinica;
             codi_equipo_playlist = clinica_equipo_data.codi_clinica;

            
             


// RECUPERAR ID VIDEO_CORPORATIVO MÁS ALTO


         db.collection("seccions").where("idclinica" , "==" ,clinicaid_equipo).orderBy("indice","desc").limit(1).get().then(function(Snapshot) {


               Snapshot.forEach(function(doc_equipo) {


                  var equipo_update = doc_equipo.data();
             
                // SUMAR 1 AL CODIGO PERSONAL PARA CREAR EL NUEVO EQUIPOID
                  var indice_num = equipo_update.indice + 1;
             
                  var nuevo_equipoid = clinicaid_equipo + indice_num;
                  

                console.log("Document data promocion:", doc_equipo.data());
                console.log("el indice es ", indice_num);
                 
                
                 

// CREAR UNA NUEVO VIDEO

                  var añadir_equipo_ref = db.collection("seccions").doc(nuevo_equipoid);
              
                  var inicializar_equipo={
                

                    posicio: indice_num,
                    codi: codi_equipo_playlist,
                    seleccion_categorias: "",
                    seleccion_videos: "",
                    seccion_tipo: "manual",
                    seccion_activa: false,
                    tags: "tags",
                    formato_seccion: "categorias",
                    title: "Nueva Sección",
                    indice: indice_num,
                    idclinica: clinicaid_equipo,
                    clinica: refclinicaid_equipo 

                
                   };
          
                   añadir_equipo_ref.set(inicializar_equipo, { merge: true });
         
       
                 });
             });



            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
              }
              }).catch(function(error) {
                console.log("Error getting document:", error);
          });


}



//AÑADIR VIDEO_CORPORATIVO


if (key == "añadir_video"){

  var clinica_equipo_data;
  var codi_clinica_equipo;
  var codi_equipo_playlist;
  var codi_clinica_equipo;
  var codi_equipo_playlist;


  var datetime_equipo = new Date();
  var clinica_equipo_data;


  var refcategoria =  db.collection("categories").doc("1Cwi4AmOn02nc9eOPSQ9");

  var clinicaid_equipo = firebasePath.replace("cliniques/","");
  var refclinicaid_equipo = db.collection("cliniques").doc(clinicaid_equipo);
  

                
  refclinicaid_equipo.get().then(function(doc) {
    if (doc.exists) {
            console.log("Document data:", doc.data());
            clinica_equipo_data = doc.data();


             codi_clinica_equipo = clinica_equipo_data.codi_clinica;
             codi_equipo_playlist = clinica_equipo_data.codi_clinica_playlist;

            
             


// RECUPERAR ID VIDEO_CORPORATIVO MÁS ALTO


         db.collection("videos_corporativos").where("idclinica" , "==" ,clinicaid_equipo).orderBy("indice","desc").limit(1).get().then(function(Snapshot) {


               Snapshot.forEach(function(doc_equipo) {


                  var equipo_update = doc_equipo.data();
             
                // SUMAR 1 AL CODIGO PERSONAL PARA CREAR EL NUEVO EQUIPOID
                  var indice_num = equipo_update.indice + 1;
                  var nuevo_equipoid = clinicaid_equipo + indice_num;
                  

                console.log("Document data promocion:", doc_equipo.data());
                console.log("el indice es ", indice_num);
                 
                
                 

// CREAR UNA NUEVO VIDEO

                  var añadir_equipo_ref = db.collection("videos_corporativos").doc(nuevo_equipoid);
              
                  var inicializar_equipo={
                

                    video: "",
                    title: "Nombre del Vídeo",
                    audio: true,
                    photo: "",
                    indice: indice_num,
                    tags:"tags",
                    created: datetime,
                    photo: "https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/portada-videos-tablet.jpg?alt=media&token=bb79deda-a763-4962-ac60-7109ee49a42e",
                    photo_vertical:"https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/portada-videos-digimevo-app.jpg?alt=media&token=01f2ce32-4c03-40a4-bb72-716c8461cfd6",
                    categories1 : refcategoria,
                    categories2 : refcategoria,
                    categories3 : refcategoria,
                    categories4 : refcategoria,
                    categories5 : refcategoria,
                    traduccions : ["español","català","english"],
                    video_idioma_corporativo : ",español",
                    video_plan : ",standard",
                    sub_es: "", 
                    video_audience:"private",
                    video_type:"corporativo",
                    descrip:["Descripción del vídeo para la Tablet","Descripció del Vídeo per a la tablet","Tablet Video Description"],
                    idclinica: clinicaid_equipo,
                    refclinica: refclinicaid_equipo 

                
                   };
          
                   añadir_equipo_ref.set(inicializar_equipo, { merge: true });
         
       
                 });
             });



            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
              }
              }).catch(function(error) {
                console.log("Error getting document:", error);
          });


}

//AÑADIR PLAYLIST

if (key == "añadir_playlist"){

  


  var clinicaid_playlist = firebasePath.replace("cliniques/","");
  var refclinicaid_playlist = db.collection("cliniques").doc(clinicaid_playlist);
  

               
  refclinicaid_playlist.get().then(function(doc) {
    if (doc.exists) {
            console.log("Document data:", doc.data());
           var   clinica_playlist_data = doc.data();


             var nombreclinica_playlist = clinica_playlist_data.nombreclinica;
             




// RECUPERAR EL CODIGO DE CLINICA MAS ALTO 

        console.log("El id de clinica es ", clinicaid_playlist);

         db.collection("playlists").orderBy("codi","desc").limit(1).get().then(function(Snapshot) {


               Snapshot.forEach(function(doc_playlist) {


                  var playlist_update = doc_playlist.data();
             
                // SUMAR 1 AL CODIGO PERSONAL PARA CREAR EL NUEVO CODIGO PARA LA CLINICA
                   
                     var nuevo_playlist_codi = playlist_update.codi + 1;
                     var playslitdoc = clinicaid_playlist + nuevo_playlist_codi;
                  

                 
                 console.log("la nueva playlist es es ", nuevo_playlist_codi);
                 
                
                

// CREAR UNA NUEVA PLAYLIST

                  var añadir_playlist_ref = db.collection("playlists").doc(playslitdoc);
              
                  var inicializar_playlist={
                
                    capsules_freq:5,
                    codi:nuevo_playlist_codi,
                    created:datetime,
                    updated:datetime,
                    colorPrimari_playlist:"#ffffff",
                    colorSecundari_playlist:"#0d6875",
                    color_twitter:"#ffffff",
                    distribucion_tiempo_pantalla:"25,25,25,25,0",
                    frecuencia_videos_promocion:1,
                    corporatius_freq:10,
                    promocio_freq:5,
                    fuente:"acme",
                    clinica:nombreclinica_playlist,
                    numero_promociones_por_video:1,
                    logo_hora:"https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/imagenes_usuarios%2F1561319839800.jpg?alt=media&token=9caa26e3-42d2-42dd-86c1-8dc70f36315a",
                    idclinica:clinicaid_playlist,
                    title:"Nueva Playlist",
                    promocions_size:5,
                    sub_size:5,
                    promocions_time_sec:60,
                    twitter_mostrar:true,
                    twitter_offline_mostrar: false,
                    sub_back: "#ffffff",
                    sub_color: "#911b1d",
                    turno_size:0,
                    seleccion_videos_playlist:"",
                    tiempo_ciudad:"Barcelona",
                    tipo_banner_superior:"imagen",
                    tipo_banner_inferior:"imagen",
                    turno_web:"",
                    twitter_offline:["Quieres cuidar tu salud? Gracias al sistema POC de Digimevo  tendrás acceso a más de 1000 vídeos educativos en la sala de espera","Los sistemas POC combinan las últimas tencologías con el mejor contenido audiovisual para ofrecerte una experiencia educativa única"],
                    twitter:["salutcat","MedlinePlusEsp","sanidadgob"] 

         
                   };
          
                   console.log("Document data playlist:", inicializar_playlist);
                   añadir_playlist_ref.set(inicializar_playlist, { merge: true });
         
    
                 });
             });



            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
              }
              }).catch(function(error) {
                console.log("Error getting document:", error);
          });


}

//AÑADIR PROMOCION

if (key == "añadir_promocion"){

  var clinica_equipo_data;
  var codi_clinica_equipo;
  var codi_equipo_playlist;
  var codi_clinica_equipo;
  var codi_equipo_playlist;


  var datetime_equipo = new Date();
  var clinica_equipo_data;




  var clinicaid_equipo = firebasePath.replace("cliniques/","");
  var refclinicaid_equipo = db.collection("cliniques").doc(clinicaid_equipo);
  

                
  refclinicaid_equipo.get().then(function(doc) {
    if (doc.exists) {
            console.log("Document data:", doc.data());
            clinica_equipo_data = doc.data();


             codi_clinica_equipo = clinica_equipo_data.codi_clinica;
             codi_equipo_playlist = clinica_equipo_data.codi_clinica_playlist;




// RECUPERAR ID EQUIPO MÁS ALTO


         db.collection("promocions").where("idclinica" , "==" ,clinicaid_equipo).orderBy("indice","desc").limit(1).get().then(function(Snapshot) {


               Snapshot.forEach(function(doc_equipo) {


                  var equipo_update = doc_equipo.data();
             
                // SUMAR 1 AL CODIGO PERSONAL PARA CREAR EL NUEVO EQUIPOID
                  var indice_num = equipo_update.indice + 1;
                  var nuevo_equipoid = clinicaid_equipo + indice_num;
                  

                console.log("Document data promocion:", doc_equipo.data());
                console.log("el indice es ", indice_num);
                 
                
                 

// CREAR UNA NUEVA PROMO 

                  var añadir_equipo_ref = db.collection("promocions").doc(nuevo_equipoid);
              
                  var inicializar_equipo={
                

                    codi_playlist: codi_equipo_playlist,
                    title: "Nueva Promo",
                    photo: "https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/1539169528565.jpg?alt=media&token=58130495-8dba-4f81-b390-2edd87f363b6",
                    tipo_promo:",banner_tv",
                    color_fondo_promo:"#ffffff",
                    color_letra_promo:"#000000",
                    letra_promocion:5,
                    mostrar_color_fondo: true,
                    categorias_relacionadas: "",
                    indice: indice_num,
                    secciones_relacionadas: "",
                    tipo_transicion:"fade",
                    formato_promo:"manual",
                    videos_relacionados: "",
                    descrip:["español","català","english"],
                    tipo_promocion_relacionada:"no relacionada",
                    mostrar_texto:false,
                    texto_promocion:"Texto para la promoción",
                    duracion_video_anuncio:10,
                    promocion_activa:false,
                    idclinica: clinicaid_equipo,
                    idplaylist: clinicaid_equipo



                
                   };
          
                   añadir_equipo_ref.set(inicializar_equipo, { merge: true });
         
       
                 });
             });



            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
              }
              }).catch(function(error) {
                console.log("Error getting document:", error);
          });


}


  //AÑADIR EQUIPO



if (key=="añadir_equipo"){


  var datetime_equipo = new Date();


  var clinica_equipo_data;
  var codi_clinica_equipo;
  var codi_equipo_playlist;
  var codi_clinica_equipo;
  var codi_equipo_playlist;



  var clinicaid_equipo = firebasePath.replace("cliniques/","");
  var refclinicaid_equipo = db.collection("cliniques").doc(clinicaid_equipo);
  
// RECUPERAR CODIGO PLAYLIST


                
  refclinicaid_equipo.get().then(function(doc) {
    if (doc.exists) {
            console.log("Document data:", doc.data());
            clinica_equipo_data = doc.data();


             codi_clinica_equipo = clinica_equipo_data.codi_clinica;
             codi_equipo_playlist = clinica_equipo_data.codi_clinica_playlist;



// RECUPERAR ID EQUIPO MÁS ALTO


         db.collection("equipo").where("idclinica" , "==" ,clinicaid_equipo).orderBy("codigo_personal", "desc").limit(1).get().then(function(Snapshot) {


               Snapshot.forEach(function(doc_equipo) {


                  var equipo_update = doc_equipo.data();
             
                // SUMAR 1 AL CODIGO PERSONAL PARA CREAR EL NUEVO EQUIPOID


                  var integer_equipo = parseInt(equipo_update.codigo_personal,10);
                  var integer_codi_clinica = equipo_update.codigo_personal.replace(codi_clinica_equipo,"");
                  var integer_equipo_posicion = parseInt(integer_codi_clinica,10) - 999; 
                  integer_equipo++;   
                  var string_equipo = integer_equipo.toString();
                  var nuevo_equipoid = clinicaid_equipo + string_equipo;
                  console.log("añadir equipo en posicion",integer_equipo_posicion);
                  console.log("añadir equipo con el nuevo docid",nuevo_equipoid);



                  var añadir_equipo_ref = db.collection("equipo").doc(nuevo_equipoid);
              
                  var inicializar_equipo={
                
          
                   
                      nombre_apellidos: "Nombre y Apellidos",
                      actualizar_promociones_equipo: "Actualizar",
                      secciones_medicas: "",
                      promocion_equipo_tv: false,
                      texto_promocion_equipo: "",
                      foto_promocion_equipo: "https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/doctor%20-%20cercle%20.png?alt=media&token=2812e99d-491a-43d8-8928-64e2da13c70e",
                      foto_personal: "https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/portada-equipo-m%C3%A9dico-v03-app.jpg?alt=media&token=8e367812-c0e3-48c9-90ff-1e31a5b182fb",
                      icono_personal:"https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/doctor%20-%20cercle%20.png?alt=media&token=2812e99d-491a-43d8-8928-64e2da13c70e",
                      descripcion_breve: ["Breve Descripción","català","english","français","german","italiano","portugues"],
                      decripcion_larga: ["Descripción Completa sobre la persona del Equipo","català","english","français","german","italiano","portugues"],
                      created: datetime_equipo,
                      posicion_equipo: integer_equipo_posicion, 
                      horario_visitas : "true,9,14,16,20,true,9,14,16,20,true,9,14,16,20,true,9,14,16,20,true,9,14,16,20,false,0,0,0,0,false,0,0,0,0",
                      telefono_fijo: "",
                      telefono_movil : "",
                      skype: "", 
                      zoom:"",
                      correo_electronico:"",
                      metodo_contacto:"",
                      codigo_personal: string_equipo,
                      idclinica: clinicaid_equipo,
                      refclinica: refclinicaid_equipo
                
                   };
          
                   añadir_equipo_ref.set(inicializar_equipo, { merge: true });
         
                var promo_equipo_id = clinicaid_equipo + nuevo_equipoid;


  // CREAR PROMOS POR CADA EQUIPO



                var promoequipoRef = db.collection("promocions").doc(promo_equipo_id);


                var updatepromoequipo={
                   codi_playlist: codi_equipo_playlist,
                   title: "Nombre y Apellidos",
                   photo: "https://firebasestorage.googleapis.com/v0/b/silver-script-200209.appspot.com/o/doctor%20-%20cercle%20.png?alt=media&token=2812e99d-491a-43d8-8928-64e2da13c70e",
                   tipo_promo:",imagen_video_tv",
                   color_fondo_promo:"#ffffff",
                   color_letra_promo:"#000000",
                   letra_promocion:5,
                   mostrar_color_fondo: true,
                   categorias_relacionadas: "",
                   secciones_relacionadas: "",
                   tipo_transicion:"fade",
                   videos_relacionados:"",
                   formato_promo:"equipo",
                   descrip:["español","català","english"],
                   tipo_promocion_relacionada:"secciones",
                   mostrar_texto:true,
                   texto_promocion:"Texto para la promoción",
                   duracion_video_anuncio:10,
                   promocion_activa:false,
                   codiequipo: string_equipo,
                   idclinica: clinicaid_equipo,
                   idplaylist: clinicaid_equipo,
                   refclinica: refclinicaid_equipo
        
                 };
               


                 promoequipoRef.set(updatepromoequipo, { merge: true });




                  console.log("creando promo doc",promo_equipo_id);


                 });
             });



            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
              }
              }).catch(function(error) {
                console.log("Error getting document:", error);
          });
   

}





  // UPDATE EQUIPO_PROMOS



if ((key=="foto_promocion_equipo") || (key=="texto_promocion_equipo") || (key=="secciones_medicas") || (key=="texto_promocion_equipo") || (key=="promocion_equipo_tv")){

  var docidequipo;
  var equipoupdatedata;
  var equipoupdateid;
  var equipoid = firebasePath.replace("equipo/","");
  var refequipoid = db.collection("equipo").doc(equipoid);

   //GET IDCLINICA 

  refequipoid.get().then(function(doc) {
    if (doc.exists) {
            console.log("Document data:", doc.data());
            equipoupdatedata = doc.data();
            equipoupdateid = doc.id;

           
     
       docidequipo= equipoupdatedata.idclinica + equipoid;
       var promosRef = dbvideosdb.collection("promocions").doc(docidequipo);
       var datetime = new Date();
       


       var update_equipo={

         idclinica: equipoupdatedata.idclinica,
         refclinica: equipoupdatedata.refclinica,
         idequipo: equipoupdateid,
         codiequipo: equipoupdatedata.codigo_personal,
         title: equipoupdatedata.nombre_apellidos,
         texto_promocion: equipoupdatedata.texto_promocion_equipo,
         secciones_relacionadas: equipoupdatedata.secciones_medicas,
         photo: equipoupdatedata.foto_promocion_equipo,
         promocion_activa: equipoupdatedata.promocion_equipo_tv
         };

       promosRef.set(update_equipo, { merge: true });


      } else {
        // doc.data() will be undefined in this case
   console.log("No such document!");
    }
      }).catch(function(error) {
 console.log("Error getting document:", error);
  });


}

 
// UPDATE PROMOS

        if (key=="codi_playlist"){

       

          var promocionsid = firebasePath.replace("promocions/","");


          dbdata.collection("usuaris").where("email" , "==" ,usuaripromocions.email).get().then(function(querySnapshot) {
     
            querySnapshot.forEach(function(doc) {
        
                  

                        databaseupdate.collection("playlists").where("codi", "==", value).get().then(function(Snapshot) {

      
                           Snapshot.forEach(function(docupdate) {

                              
                            
                            
                               playlistupdate = docupdate.data();
                               playlistupdateid = docupdate.id;

                               usuariclinica = doc.data();

                               // VERIFICA QUE ES UNA PLAYLIST DE LA CLINICA

                               if ( usuariclinica.clinica == playlistupdate.idclinica ){

                   
                                   var promocionsRef = dbvideosdb.collection("promocions").doc(promocionsid);
      
                                    var updatepromocions={

                                    codi_playlist: value,
                                    idplaylist: playlistupdateid
  
                                   };

                                    promocionsRef.set(updatepromocions, { merge: true });
               
                                  }
        
                        });
                    });
              });
          });



          }else {


            databaseRef.set(updateObj, { merge: true });




          }


/*
   document.write ("El valor string ",value);
   document.write ("El valor number ",intcodi);
   document.write ("El idplaylist es",playlistupdateid);
    
  updateObj["idplaylist"]=playlistupdateid;
*/


// UPDATE VIDEO CATEGORIES i IDIOMA  DISPONIBLES PER CLINICA (TV && TABLET) Y SECCIONS   

var video_idioma;
var stringidiomaclinica;
var idiomastring;
var numerovideospremium;
var maxvideospremium;
var refclinicavideodisponible;
var videodisponibletablet;
var videodisponibleapp;
var videodisponibletv;
var videodisponibleplan;
var clinicadata;
var videopremiumactive;
var numeroactualpremium;

if ((key=="app") || (key=="tv") || (key=="tablet")){



        
        var videodisponibleid = firebasePath.replace("videos_disponibles/","");
        var refvideodisponible = db.collection("videos_disponibles").doc(videodisponibleid);
      

        var videodisponibleupdate;
        
        // GET REF CLINICA DE VIDEOS DISPONIBLES
      
        refvideodisponible.get().then(function(doc) {
          if (doc.exists) {

                  console.log("Document data:", doc.data());
                  videodisponibleupdate = doc.data();
                 refclinicavideodisponible = videodisponibleupdate.idclinica;
                 videopremiumactive = videodisponibleupdate.videopremiumactive;
                 videodisponibletablet = videodisponibleupdate.tablet;
                 videodisponibleapp = videodisponibleupdate.app;
                 videodisponibletv = videodisponibleupdate.tv;
                 videodisponibleplan = videodisponibleupdate.video_plan;

                

              

        

                  refclinicavideodisponible.get().then(function(docclinic) {
                    if (docclinic.exists) {
                            console.log("Document data:", docclinic.data());
                            clinicadata = docclinic.data();
                            maxvideospremium = clinicadata.videos_premium;
                            numeroactualpremium = clinicadata.videospremiumactuales;
                      





        // GET MAX NUMERO DE VIDEOS
  /*      
        document.write("valor id",refclinicavideodisponible);
      document.write("Premium",videopremiumactive);
        document.write("tablet",videodisponibletablet);
        document.write("app",videodisponibleapp);
        document.write("tv",videodisponibletv);



          document.write("El valor Max de videos es",maxvideospremium);
          document.write("El Numero de videos premium es",numeroactualpremium);
         

*/

        if ( videodisponibleplan == ",premium"){

          if ( value == true ){
              

             if ( videopremiumactive != true  ){
            
// ACTIVACIÓN NUEVA DEL VIDEO

                     if ( maxvideospremium > numeroactualpremium ) {

                      // TIENE SUFICIENTES VIDEOS PREMIUM

                      //ACTUALIZO ESTADO ACTUAL VIDEOS PREMIUM

                 
                              // PONGO COMO ACTIVO EL VIDEO PREMIUM

                              
                              dontupdate = true;


                              var updatevideos={

              
                                videopremiumactive: true

                             };

                             updatevideos[key]=value;
                             refvideodisponible.set(updatevideos, { merge: true });

         

                             numeroactualpremium++;

                             

                             var updatenumerovideospremium={

                               
                             videospremiumactuales: numeroactualpremium

                             };

                             refclinicavideodisponible.set(updatenumerovideospremium, { merge: true });



                     }else{

                      // NO TIENE SUFICIENTES VIDEOS PREMIUM MARCO COMO FALSE 

                              
                               dontupdate = true;

                               var updatevideos={

                         
                                 app: false,
                                 tablet: false,
                                 tv:false

                                 };

                             refvideodisponible.set(updatevideos, { merge: true });
              

                     }


                    }else {

                      dontupdate = true;

                      updateObj[key]=value;

                      databaseRef.set(updateObj, { merge: true });



                    }
                       


              }

              if ( (value == false) && (videopremiumactive == true)){


                //HA DESMARCADO UN VIDEO PREMIUM Y DEBEMOS REDUCIR EL NUMERO DE VIDEOSPREMIUM USADOS

                // VERIFICAR QUE TODAS LAS VARIABLES ESTAN EN FALSE
                var multiplesdispositivos = 0;

                if (videodisponibletablet == false ){
                
                    multiplesdispositivos++;

                } 


                if (videodisponibleapp == false ){
                
                  multiplesdispositivos++;

                 } 

                if (videodisponibletv == false ){
                
                  multiplesdispositivos++;

                } 
                
                


                if ( multiplesdispositivos > 1 ){

                       dontupdate = true;

                        var updatevideos={

                    
                       videopremiumactive: false
 
                        };


                       updatevideos[key]=value;
                        refvideodisponible.set(updatevideos, { merge: true });





                          numeroactualpremium--;

                          var updatenumerovideospremium={


                          videospremiumactuales: numeroactualpremium

                          };

                          refclinicavideodisponible.set(updatenumerovideospremium, { merge: true });


                  // MARCAMOS VIDEO COMO NO ACTIVO 

                  
                        }else{


                          // ACTUALIZAMOS EL VALOR  PERO NO HACEMOS MODIFICACIONES EN EL VIDEO

                                dontupdate = true;

                                updateObj[key]=value;

                                databaseRef.set(updateObj, { merge: true });

                        
                        
                        }

                  }

                }
                           } else {
                           // doc.data() will be undefined in this case
                          console.log("No such document!");
                          }
                         }).catch(function(error) {
                         console.log("Error getting document:", error);
                         });

    
                    
                } else {
                  // doc.data() will be undefined in this case
                  console.log("No such document!");
                  }
                  }).catch(function(error) {
                    console.log("Error getting document:", error);
              });
          
    
         
            

}



       
if (key=="actualizar_videos_disponibles"){
      
      
                              // Remove from firebasepath the videos/ part
                              
                     
                           var clinicaid = firebasePath.replace("cliniques/","");
                           var refclinicaid = db.collection("cliniques").doc(clinicaid);
      
                           var videosactuales;
      
                           refclinicaid.get().then(function(doc) {
                            if (doc.exists) {
                                    console.log("Document data:", doc.data());
                                    clinicaupdatedata = doc.data();
                                    stringcategoriesclinica = clinicaupdatedata.categories_videos;
                                    stringidiomaclinica = clinicaupdatedata.idioma;
                                    maxvideospremium = clinicaupdatedata.videos_premium;
                                    videosactuales = clinicaupdatedata.videospremiumactuales;
       
       
                               } else {
                                // doc.data() will be undefined in this case
                                console.log("No such document!");
                                }
                                }).catch(function(error) {
                                  console.log("Error getting document:", error);
                            });
      
                            numerovideospremium = 0 ;
                              // XAVI ACTUALITZA ELS VIDEOS DISPONIBLES   
      
                            databaseupdate.collection("videos_disponibles").where("idclinica" ,"==", refclinicaid).get().then(function(Snapshot) {
           
                             
                              Snapshot.forEach(function(docupdate) {
      
      
                                var videodisponibledata = docupdate.data();
                                var videoupdateid = docupdate.id;
                                
                                
                                categoria1string = videodisponibledata.categoria1updatedata_value;
                                categoria2string = videodisponibledata.categoria2updatedata_value;
                                categoria3string = videodisponibledata.categoria3updatedata_value;
                                categoria4string = videodisponibledata.categoria4updatedata_value;
                                categoria5string = videodisponibledata.categoria5updatedata_value;
                                idiomastring = videodisponibledata.video_idioma;
                              
                                 
      
                                           
                                           var busquedacategoria1 = stringcategoriesclinica.search(categoria1string); 
                                           var busquedacategoria2 = stringcategoriesclinica.search(categoria2string); 
                                           var busquedacategoria3 = stringcategoriesclinica.search(categoria3string); 
                                           var busquedacategoria4 = stringcategoriesclinica.search(categoria4string); 
                                           var busquedacategoria5 = stringcategoriesclinica.search(categoria5string); 
                                           var busquedaidioma = stringidiomaclinica.search(idiomastring); 
                                           var busquedapremium = videodisponibledata.video_plan.search(",premium"); 

                                           if ((busquedaidioma != -1)){

                                            // IDIOMA ACTIVO
                                                  var busquedastandard = videodisponibledata.video_plan.search(",standard"); 


                                               if ((busquedacategoria1 != -1) || (busquedacategoria2 != -1) || (busquedacategoria3 != -1)  || (busquedacategoria4 != -1)  || (busquedacategoria5 != -1) ){
                                                    // EXISTEIX LA CATEGORIA
                                                     var videosRef = dbvideosdb.collection("videos_disponibles").doc(videoupdateid);
      // ES VIDEO PREMIUM 
                                                     if ((busquedapremium != -1) && (numerovideospremium < maxvideospremium)){

                                                          numerovideospremium++;

                                                              var updatevideos={

                                                                
                                                                videosdisponiblespremium: true,
                                                                app: true,
                                                                tablet: true,
                                                                tv:true

                                                                };

                                                       videosRef.set(updatevideos, { merge: true });


                                                       var clinicaRef = db.collection("cliniques").doc(clinicaid);


                                                       var updatenumerovideospremium={
                           
                                                          
                                                         videospremiumactuales: numerovideospremium
                           
                                                        };
                           
                                                      clinicaRef.set(updatenumerovideospremium, { merge: true });


                                                      }

// ES UN VIDEO STANDARD

                                                      if (busquedastandard != -1){
                                                

                                                           var updatevideos={

                                                                   
                                                                     app: true,
                                                                     tablet: true,
                                                                      tv:true

                                                                 };

                                                         videosRef.set(updatevideos, { merge: true });
                                                         }
                                            
      
                                                   }else{
      
                                                  //NO EXISTEIX LA CATEGORIA
                                                      var videosRef = dbvideosdb.collection("videos_disponibles").doc(videoupdateid);
      
                                                      var updatevideos={

                                                         
                                                         app: false,
                                                         tablet: false,
                                                         tv:false
      
                                                        };
      
                                                      videosRef.set(updatevideos, { merge: true });
      
                                                       }
      
                                            }else{

                                              //IDIOMA NO ACTIVO


                                              

                                              if ((busquedapremium != -1) && ( videosactuales > 0 )) {

                                                      videosactuales--;

                                                      var videosRef = dbvideosdb.collection("videos_disponibles").doc(videoupdateid);
  
                                                      var updatevideos={
// ES UN VIDEO PREMIUM
                                                          videosdisponiblespremium: false,
                                                          app: false,
                                                          tablet: false,
                                                          tv:false
                                  
                                                       };
                                  
                                                      videosRef.set(updatevideos, { merge: true });      
                                                      
                                                      
                                                      
                                                      
                                                      
                                                      var clinicaRef = db.collection("cliniques").doc(clinicaid);


                                                       var updatenumerovideospremium={
                           
                                                          
                                                         videospremiumactuales: videosactuales
                           
                                                        };
                           
                                                      clinicaRef.set(updatenumerovideospremium, { merge: true });




                                              }else{


                                                var videosRef = dbvideosdb.collection("videos_disponibles").doc(videoupdateid);
  
                                                var updatevideos={
                                                    
                                                    app: false,
                                                    tablet: false,
                                                    tv:false
                            
                                                 };
                            
                                                videosRef.set(updatevideos, { merge: true });



                                              }



                                            }
      
                              });
                            });
      
                           
// XAVI RESET VALUE VIDEOS

                            value = false;


                          }


// UPDATE DATA VALUE




updateObj[key]=value;

//document.write ("valor dontupdate",dontupdate);

if ( dontupdate == false ){

databaseRef.set(updateObj, { merge: true });

}


                }


      }
  }

  /**
  * addDocumentToCollection  - used recursivly to add collection's document's collections
  * @param {String} name name of the collection
  * @param {FirestoreReference} reference
  */
  addDocumentToCollection(name,reference=null){

    var pathChunks=this.state.firebasePath.split("/");
    pathChunks.pop();
    var withoutLast = pathChunks.join("/");
    console.log(name+" vs "+withoutLast);
    //Find the fields to be inserted
    var theInsertSchemaObject=INSERT_STRUCTURE[name].fields;
    console.log(JSON.stringify(theInsertSchemaObject));

    //Find the collections to be inserted
    var theInsertSchemaCollections=INSERT_STRUCTURE[name].collections;
    console.log(JSON.stringify(theInsertSchemaCollections));

    //Reference to root firestore or existing document reference
    var db = reference==null?(pathChunks.length>1?firebase.app.firestore().doc(withoutLast):firebase.app.firestore()):reference;
    
    //Check type of insert
    var isTimestamp=Config.adminConfig.methodOfInsertingNewObjects=="timestamp"

    //Create new element
    var newElementRef=isTimestamp?db.collection(name).doc(Date.now()):db.collection(name).doc()
    
    //Add data to the new element
    newElementRef.set(theInsertSchemaObject)

    //Go over sub collection and insert them
    for (var i = 0; i < theInsertSchemaCollections.length; i++) {
      this.addDocumentToCollection(theInsertSchemaCollections[i],newElementRef)
    }


    //Show the notification on root element
    if(reference==null){
      this.cancelAddFirstItem();
      this.setState({notifications:[{type:"success",content:"Element added. You can find it in the table bellow."}]});
      this.refreshDataAndHideNotification();
    }   
   }

  /**
  * addKey
  * Adds key in our list of fields in firestore
  */
  addKey(){
    if(this.state.NAME_OF_THE_NEW_KEY&&this.state.NAME_OF_THE_NEW_KEY.length>0){
     
      if(this.state.VALUE_OF_THE_NEW_KEY&&this.state.VALUE_OF_THE_NEW_KEY.length>0){
        
        this.setState({notifications:[{type:"success",content:"New key added."}]});
        this.updateAction(this.state.NAME_OF_THE_NEW_KEY,this.state.VALUE_OF_THE_NEW_KEY);
        this.refs.simpleDialog.hide()
        this.refreshDataAndHideNotification();
      }
    }
  }

  /**
  * addItemToArray  - add item to array
  * @param {String} name name of the array
  * @param {Number} howLongItIs count of items, to know the next index
  */
  addItemToArray(name,howLongItIs){
    console.log("Add item to array "+name);
    console.log("Is just array "+this.state.isJustArray);

    console.log("Data ");
    console.log(this.state.fieldsOfOnsert);

    var dataToInsert=null;
    var correctPathToInsertIn="";
    if(this.state.fieldsOfOnsert){
        if(this.state.isJustArray){
          console.log("THIS IS Array")
            dataToInsert=this.state.fieldsOfOnsert[0];
            correctPathToInsertIn=this.state.firebasePath+Config.adminConfig.urlSeparatorFirestoreSubArray+(parseInt(howLongItIs));
        }else{
            dataToInsert=this.state.fieldsOfOnsert[name];
            dataToInsert=dataToInsert?dataToInsert[0]:null;
            correctPathToInsertIn=this.state.firebasePath+Config.adminConfig.urlSeparatorFirestoreSubArray+name+Config.adminConfig.urlSeparatorFirestoreSubArray+(parseInt(howLongItIs));
        }
    }

    console.log("Data to insert");
    console.log(dataToInsert);
    console.log("Path to insert");
    console.log(correctPathToInsertIn);
   
    var _this=this;
    this.updatePartOfObject("DIRECT_VALUE_OF_CURRENT_PATH",dataToInsert,true,null ,this.state.firebasePath,correctPathToInsertIn,function(e){
       _this.setState({notifications:[{type:"success",content:"New element added."}]});
      _this.refreshDataAndHideNotification();
    })
  }

  /**
  *
  * C Read U D
  *
  */

  /**
  * showSubItems - displays sub object, mimics opening of new page
  * @param {String} theSubLink , direct link to the sub object
  */
  showSubItems(theSubLink){
    var chunks = theSubLink.split(Config.adminConfig.urlSeparatorFirestoreSubArray);
    this.setState({
      itemOfInterest:chunks[1],
      theSubLink:theSubLink,
    })
    var items=this.state.records;
    for (var i = 1; i < chunks.length; i++) {
      console.log(chunks[i]);
      items=items[chunks[i]];
    }
    console.log("--- NEW ITEMS ");
    console.log(items)
    this.processRecords(items);
  }

  /**
  *
  * C R U Delete
  *
  */

  /**
  * deleteFieldAction - displays sub object, mimics opening of new page
  * @param {String} key to be updated
  * @param {Boolean} isItArrayItem 
  * @param {String} theLink 
  */
  deleteFieldAction(key,isItArrayItem=false,theLink=null){
    console.log("Delete "+key);
    console.log(theLink);
    if(theLink!=null){
      theLink=theLink.replace("/firestoreadmin","");
    }
    if(isNaN(key)){
      isItArrayItem=false;
    }
    console.log("Is it array: "+isItArrayItem);
    var firebasePathToDelete=(this.props.route.path.replace(ROUTER_PATH,"").replace(":sub",""))+(this.props.params&&this.props.params.sub?this.props.params.sub:"").replace(/\+/g,"/");
    if(key!=null){
      //firebasePathToDelete+=("/"+key)
    }

    console.log("firebasePath for delete:"+firebasePathToDelete);
    this.setState({pathToDelete:theLink?theLink:firebasePathToDelete,isItArrayItemToDelete:isItArrayItem,keyToDelete:theLink?"":key});
    window.scrollTo(0, 0);
    this.refs.deleteDialog.show();

  }

  /**
  * doDelete - do the actual deleting based on the data in the state
  */
  doDelete(){
    var _this=this;
    console.log("Do delete ");
    console.log("Is it array "+this.state.isItArrayItemToDelete);
    console.log("Path to delete: "+this.state.pathToDelete)
    var completeDeletePath=this.state.pathToDelete+"/"+this.state.keyToDelete;
    console.log("completeDeletePath to delete: "+completeDeletePath)
    if(this.state.pathToDelete.indexOf(Config.adminConfig.urlSeparatorFirestoreSubArray)>-1){
      //Sub data
      _this.refs.deleteDialog.hide();
       this.updatePartOfObject("DIRECT_VALUE_OF_CURRENT_PATH","DELETE_VALUE",true,null ,this.state.firebasePath,this.state.pathToDelete,function(e){
         _this.setState({notifications:[{type:"success",content:"Element deleted."}]});
        _this.refreshDataAndHideNotification();
      })
    }else{
      //Normal data

      var chunks=completeDeletePath.split("/");

      var db = firebase.app.firestore();
     

      if(chunks.length%2){
        //odd
        //Delete fields from docuemnt
        var refToDoc = db.doc(this.state.pathToDelete);

        // Remove the 'capital' field from the document
        var deleteAction={};
        deleteAction[this.state.keyToDelete]=firebaseREF.firestore.FieldValue.delete();
        var removeKey = refToDoc.update(deleteAction).then(function() {
            console.log("Document successfully deleted!");
            _this.refs.deleteDialog.hide();
            _this.setState({keyToDelete:null,pathToDelete:null,notifications:[{type:"success",content:"Field is deleted."}]});
            _this.refreshDataAndHideNotification();
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
      }else{
        //even
        //delete document from collection
        //alert("Delete document "+completeDeletePath);
        db.collection(this.state.pathToDelete).doc(this.state.keyToDelete).delete().then(function() {
            console.log("Document successfully deleted!");
            _this.refs.deleteDialog.hide();
            _this.setState({pathToDelete:null,notifications:[{type:"success",content:"Field is deleted."}]});
            _this.refreshDataAndHideNotification();
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
        
      }

    }
    

    

    /*firebase.database().ref(this.state.pathToDelete).set(null).then((e)=>{
      console.log("Delete res: "+e)
      this.refs.deleteDialog.hide();
      this.setState({keyToDelete:null,pathToDelete:null,notifications:[{type:"success",content:"Field is deleted."}]});
      this.refreshDataAndHideNotification();

    })*/
  }

  /**
  * cancelDelete - user click on cancel
  */
  cancelDelete(){
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  cancelAddFirstItem(){
    console.log("Cancel Add");
    this.refs.addCollectionDialog.hide()
  }



   /**
   *
   * UI GENERATORS
   *
   */

  /**
  * This function finds the headers for the current menu
  * @param firebasePath - we will use current firebasePath to find the current menu
  */
  findHeadersBasedOnPath(firebasePath){
     var headers=null;

     var itemFound=false;
     var navigation=Config.navigation;
     for(var i=0;i<navigation.length&&!itemFound;i++){
       if(navigation[i].path==firebasePath&&navigation[i].tableFields&&navigation[i].link=="firestoreadmin"){
         headers=navigation[i].tableFields;
         itemFound=true;
       }

       //Look into the sub menus
       if(navigation[i].subMenus){
         for(var j=0;j<navigation[i].subMenus.length;j++){
           if(navigation[i].subMenus[j].path==firebasePath&&navigation[i].subMenus[j].tableFields&&navigation[i].subMenus[j].link=="firestoreadmin"){
             headers=navigation[i].subMenus[j].tableFields;
             itemFound=true;
           }
         }
       }
     }
     return headers;
  }

  /**
  * makeCollectionTable
  * Creates single collection documents
  */
  makeCollectionTable(){
      var name=this.state.currentCollectionName;
      return (
          <div className="col-md-12" key={name}>
              <div className="card">
                  <div className="card-header card-header-icon" data-background-color="purple">
                      <i className="material-icons">assignment</i>
                  </div>
                 {/*Xavi remove add button <a  onClick={()=>{this.addDocumentToCollection(name)}}><div id="addDiv" className="card-header card-header-icon" data-background-color="purple" style={{float:"right"}}>
                      <i className="material-icons">add</i>
      </div></a> */}
                  <div className="card-content">
                      <h4 className="card-title">{Common.capitalizeFirstLetter(name)}</h4>
                      <div className="toolbar">

                      </div>
                      <div className="material-datatables">
                        <Table
                          caller={"firestore"}
                          headers={this.findHeadersBasedOnPath(this.state.firebasePath)} 
                          deleteFieldAction={this.deleteFieldAction} 
                          fromObjectInArray={true} 
                          name={name} 
                          routerPath={this.props.route.path} 
                          isJustArray={false} 
                          sub={this.props.params&&this.props.params.sub?this.props.params.sub:""} 
                          data={this.state.documents}
                          />
                      </div>
                  </div>
              </div>
          </div>
      )
  }

  /**
   * Creates single array section
   * @param {String} name, used as key also
   */
  makeArrayCard(name){
      return (
          <div className="col-md-12" key={name}>
              <div className="card">
                  <div className="card-header card-header-icon" data-background-color="purple">
                      <i className="material-icons">assignment</i>
                  </div>
                  {/* <a  onClick={()=>{this.addItemToArray(name,this.state.arrays[name].length)}}><div id="addDiv" className="card-header card-header-icon" data-background-color="purple" style={{float:"right"}}>
                    
                     XAVI Remove add icon    <i className="material-icons">add</i>    
                  </div></a>*/}
                  <div className="card-content">
                      <h4 className="card-title">{Common.capitalizeFirstLetter(name)}</h4>
                      <div className="toolbar">

                      </div>
                      <div className="material-datatables">
                          <Table 
                          caller={"firestore"}
                          isFirestoreSubArray={true}
                          showSubItems={this.showSubItems}
                          headers={this.findHeadersBasedOnPath(this.state.firebasePath)} 
                          deleteFieldAction={this.deleteFieldAction} 
                          fromObjectInArray={false} name={name}
                          routerPath={this.props.route.path} 
                          isJustArray={this.state.isJustArray} 
                          sub={this.props.params&&this.props.params.sub?this.props.params.sub:""} 
                          data={this.state.arrays[name]}/>
                      </div>
                  </div>
              </div>
          </div>
      )
  }

  /**
   * Creates  table section for the elements object
   * @param {String} name, used as key also
   */
  makeTableCardForElementsInArray(){
      var name=this.state.lastPathItem;
      return (
          <div className="col-md-12" key={name}>
              <div className="card">
                  <div className="card-header card-header-icon" data-background-color="purple">
                      <i className="material-icons">assignment</i>
                  </div>
                 
                  <div className="card-content">
                      <h4 className="card-title">{Common.capitalizeFirstLetter(name)}</h4>
                      <div className="toolbar">

                      </div>
                      <div className="material-datatables">
                          <Table 
                          caller={"firestore"}
                          isFirestoreSubArray={true}
                          showSubItems={this.showSubItems}
                          headers={this.findHeadersBasedOnPath(this.state.firebasePath)} deleteFieldAction={this.deleteFieldAction} fromObjectInArray={true} name={name} routerPath={this.props.route.path} isJustArray={this.state.isJustArray} sub={this.props.params&&this.props.params.sub?this.props.params.sub:""} data={this.state.elementsInArray}>
                          </Table>
                      </div>
                  </div>
              </div>
          </div>
      )
  }

  /**
    * Creates direct value section
    * @param {String} value, valu of the current path
    */
   makeValueCard(value){
     return (
         <div className="col-md-12" key={name}>
             <div className="card">
                 <div className="card-header card-header-icon" data-background-color="purple">
                     <i className="material-icons">assignment</i>
                 </div>
                 <div className="card-content">
                     <h4 className="card-title">Value</h4>
                     <div className="toolbar">
                     </div>
                     <div>
                     <Input updateAction={this.updateAction} class="" theKey="DIRECT_VALUE_OF_CURRENT_PATH" value={value} />
                     </div>
                 </div>
             </div>
         </div>
     )
   }


  /**
   * generateBreadCrumb
   */
  generateBreadCrumb(){
      var subPath=this.props.params&&this.props.params.sub?this.props.params.sub:""
      var items=subPath.split(Config.adminConfig.urlSeparator);
      var path="/firestoreadmin/"
      return (<div>{items.map((item,index)=>{
        if(index==0){
          path+=item;
        }else{
          path+="+"+item;
        }

        return (<Link className="navbar-brand" to={path}>{item} <span className="breadcrumbSeparator">{index==items.length-1?"":"/"}</span><div className="ripple-container"></div></Link>)})}</div>)
  }

  /**
   * generateNotifications
   * @param {Object} item - notification to be created
   */
  generateNotifications(item){
      return (
          <div className="col-md-12">
              <Notification type={item.type} >{item.content}</Notification>
          </div>
      )
  }

  /**
  * refreshDataAndHideNotification
  * @param {Boolean} refreshData 
  * @param {Number} time 
  */
  refreshDataAndHideNotification(refreshData=true,time=3000){
    //Refresh data,
    if(refreshData){
      this.resetDataFunction();
    }

    //Hide notifications
    setTimeout(function(){this.setState({notifications:[]})}.bind(this), time);
  }

  //MAIN RENDER FUNCTION 
  render() {
    return (
      <div className="content">
        <NavBar>{this.generateBreadCrumb()}</NavBar>

        <div className="content" sub={this.state.lastSub}>

          <div className="container-fluid">

          <div style={{textAlign: 'center'}}>
            {/* LOADER */}
            {this.state.isLoading?<Loader color="#8637AD" size="12px" margin="4px"/>:""}
          </div>

           {/* NOTIFICATIONS */}
              {this.state.notifications?this.state.notifications.map((notification)=>{
                  return this.generateNotifications(notification)
              }):""}

            {/* Documents in collection */}
            {this.state.isCollection&&this.state.documents.length>0?this.makeCollectionTable():""}

            {/* DIRECT VALUE */}
              {this.state.directValue&&this.state.directValue.length>0?this.makeValueCard(this.state.directValue):""}


            {/* FIELDS */}
              {this.state.fieldsAsArray&&this.state.fieldsAsArray.length>0?(<div className="col-md-12">
                <div className="card">
               {/* XAVI Remove add icon <a  onClick={()=>{this.refs.simpleDialog.show()}}><div id="addDiv" className="card-header card-header-icon" data-background-color="purple" style={{float:"right"}}>
                  <i className="material-icons">add</i>   
                </div></a>*/}
                  <form className="form-horizontal">
                    <div className="card-header card-header-text" data-background-color="rose">
                      <h4 className="card-title">{Common.capitalizeFirstLetter(Config.adminConfig.fieldBoxName)}</h4>
                    </div>
                    {this.state.fieldsAsArray?this.state.fieldsAsArray.map((item)=>{
                      
                        return (
                        <Fields 
                          isFirestore={true}
                          parentKey={null}
                          key={item.theKey+this.state.lastSub} 
                          deleteFieldAction={this.deleteFieldAction} 
                          updateAction={this.updateAction}  
                          theKey={item.theKey} 
                          value={item.value} />)
                      

                    }):"" }


                  </form>
                </div>
              </div>):""}



            {/* COLLECTIONS */}
            {this.state.theSubLink==null&&this.state.isDocument&&this.state.collections&&this.state.collections.length>0?(<div className="col-md-12">
              <div className="card">

                  <form method="get" action="/"   className="form-horizontal">
                      <div className="card-header card-header-text" data-background-color="rose">
                          <h4 className="card-title">{"Collections"}</h4>
                      </div>
                      <br />
                      <div className="col-md-12">
                          {this.state.theSubLink==null&&this.state.collections?this.state.collections.map((item)=>{
                              var theLink="/firestoreadmin/"+this.state.completePath+Config.adminConfig.urlSeparator+item;
                              return ( <Link to={theLink}><a className="btn">{item}<div className="ripple-container"></div></a></Link>)
                          }):"" }
                      </div>


                  </form>
              </div>
            </div>):""}



            

            {/* ARRAYS */}
                {this.state.arrayNames?this.state.arrayNames.map((key)=>{
                  return this.makeArrayCard(key)
                }):""}

                {/* ELEMENTS MERGED IN ARRAY */}
                {this.state.elementsInArray&&this.state.elementsInArray.length>0?( this.makeTableCardForElementsInArray()):""}

                {/* ELEMENTS */}
                {this.state.elements&&this.state.elements.length>0?(<div className="col-md-12">
                  <div className="card">

                      <form method="get" action="/"   className="form-horizontal">
                          <div className="card-header card-header-text" data-background-color="rose">
                              <h4 className="card-title">{this.state.lastPathItem+"' elements"}</h4>
                          </div>
                          <br />
                          <div className="col-md-12">
                              {this.state.elements?this.state.elements.map((item)=>{
                                  var theLink="/fireadmin/"+this.state.completePath+Config.adminConfig.urlSeparatorFirestoreSubArray+item.uidOfFirebase;
                                  return ( <Link onClick={()=>{this.showSubItems(theLink)}}><a className="btn">{item.uidOfFirebase}<div className="ripple-container"></div></a></Link>)
                              }):"" }
                          </div>


                      </form>
                  </div>
                </div>):""}




          </div>
        </div>
        










      </div>
    )
  }
}
export default Firestoreadmin;



// WEBPACK FOOTER //
// ./src/containers/Firestoreadmin.js